import React from 'react';
import Pagination from 'react-bootstrap/Pagination';
import styles from './PaginationComponent.module.css';

const PaginationComponent = ({ itemsPerPage, totalItems, paginate, currentPage }) => {
    const pageNumbers = [];
    for (let number = 1; number <= Math.ceil(totalItems / itemsPerPage); number++) {
        pageNumbers.push(number);
    }

    return (
        <div className={styles.paginationContainer}>
            <Pagination className={`justify-content-center ${styles.paginationFixedBottom}`}>
                <Pagination.First onClick={() => paginate(1)} />
                <Pagination.Prev onClick={() => currentPage > 1 ? paginate(currentPage - 1) : null} />
                
                {pageNumbers.map(number => (
                    <Pagination.Item key={number} active={number === currentPage} onClick={() => paginate(number)}>
                        {number}
                    </Pagination.Item>
                ))}

                <Pagination.Next onClick={() => currentPage < pageNumbers.length ? paginate(currentPage + 1) : null} />
                <Pagination.Last onClick={() => paginate(pageNumbers.length)} />
            </Pagination>
        </div>
    );
};

export default PaginationComponent;